<template>
  <div class="attachment-container">
    <img v-if="!viewOnly" 
      :src="value.type.startsWith('image/') ? value.url : value.thumbnail" 
      :alt="value.name"
      class="attachment-image" />
      
    <img v-if="viewOnly && value.type.startsWith('image/')" 
      :src="value.url" 
      :alt="value.name"
      class="attachment-image" />
      
    <video v-if="viewOnly && !value.type.startsWith('image/')" 
      :src="value.url" 
      controls
      class="attachment-video"></video>
  </div>
</template>

<script>
export default {
  name: "AttachmentFrame",

  props: {
    value: Object,
    viewOnly: Boolean,
  }
};
</script>

<style>
.attachment-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.attachment-image {
  max-width: 100%;
  object-fit: contain;
}

.attachment-video {
  max-width: 100%;
  object-fit: contain;
}
</style>
